import React, {useState} from "react";
import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar";
import axios from "axios"
import { useNavigate } from "react-router-dom";
import "./Contact.css";

const Contact = () => {
  const [credentials, setCredentials] = useState({
    email: " ",
    text: " "
  });

  const navigate = useNavigate()

  const handleChange = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/email/contact`, credentials, {
        withCredentials: true,
      });
      console.log(res.data); 
      navigate("/")
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
    <Navbar/>
    <Header/>
      <div className="container">
        <div className="picture-container">
          <div className="picture">
            <svg
              width="400px"
              height="300px"
              viewBox="-150 -99 1230 1022"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <path
                d="M436.612844,783.873989 C383.646464,1018.56651 721.019595,913.998104 845.173614,771.175243 C969.327632,628.352383 1062.8876,382.230412 980.489795,310.603094 C947.305347,281.756293 855.841203,313.393833 782.453276,334.918921 C762.737736,340.701598 647.28515,389.857308 620.73246,284.637931 C613.357636,255.413983 684.801981,108.205582 678.469226,4.83555972 C674.811257,-54.8737311 640.6213,-101.236496 562.120181,-98.4819349 C432.84531,-93.9457513 336.174606,42.3294163 261.018224,135.816995 C211.526825,197.379713 160.232117,228.107983 154.506663,233.912672 C103.126466,286.003925 194.073335,-151.19202 -57.3286154,47.7276753 C-100.69372,82.0399523 -290.558853,254.241782 -187.455608,545.707939 C-168.397037,599.585276 -34.1223694,378.890577 -92.7241774,609.425338 C-151.325985,839.960099 -77.3777541,854.175414 -49.1572726,855.085459 C182.866272,862.567681 310.654632,621.150197 393.96853,604.731975 C484.706615,586.850709 437.18152,781.354203 436.612844,783.873989"
                id="Oval-3"
                stroke="none"
                fill="#ECF5FD"
                fill-rule="evenodd"
              ></path>
              <g
                id="Group-4"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(309.607565, 246.015556)"
              >
                <g id="Group" transform="translate(219.949939, 206.152341)">
                  <rect
                    id="Rectangle"
                    fill="#C45C29"
                    x="0"
                    y="0"
                    width="51.9438969"
                    height="207.775588"
                  ></rect>
                  <polyline
                    id="Path-2"
                    fill="#9D442E"
                    points="0.423450417 43.4042126 43.827663 0 0 5.36734073e-15 0 43.4042126"
                  ></polyline>
                </g>
                <g id="Group-2">
                  <path
                    d="M209.358451,207.159511 L415.552485,207.210454 L415.801615,90.0805128 C415.801615,90.0805128 415.552485,0.352910154 330.165128,0.0604725468 L107.548569,0.352910154 C107.548569,0.352910154 28.0867597,9.32633809 26.2852539,92.0527975 L26.2852539,207.00888 C26.2852539,207.00888 -47.3581603,346.027515 53.0707655,361.443917 C153.499691,376.86032 195.838426,245.591888 207.274305,208.138509"
                    id="Path"
                    fill="#DD5149"
                  ></path>
                  <path
                    d="M208.188164,207.511499 L205.66206,82.4502236 C205.66206,82.4502236 205.679141,48.7904447 180.99674,24.9616992 C170.012526,14.3573803 151.7979,4.36510328 132.324212,1.32491429 C69.0915993,-8.54682046 40.9713602,39.9843818 40.9713602,39.9843818 C40.9713602,39.9843818 24.4633041,59.9760928 25.1832043,101.217271 L25.9031045,207.511499 L208.188164,207.511499 Z"
                    id="Path-3"
                    fill="#C0342B"
                  ></path>
                  <path
                    d="M272.705459,142.034093 L272.705459,95.0174105 L272.705459,72.1195338 C272.705459,67.7005456 276.28148,64.1182478 280.713973,64.1182478 L342.61279,64.1182478 C347.03577,64.1182478 350.621304,67.6961155 350.621304,72.1195338 L350.621304,95.0748844 C350.621304,99.4938727 347.045283,103.07617 342.61279,103.07617 L298.677407,103.07617 L298.677407,142.034093 L303.660984,142.034093 C308.080586,142.034093 311.663382,145.618113 311.663382,150.038457 L311.663382,160.001678 C311.663382,164.422366 308.072573,168.006042 303.660984,168.006042 L267.721882,168.006042 C263.30228,168.006042 259.719485,164.422022 259.719485,160.001678 L259.719485,150.038457 C259.719485,145.617769 263.310293,142.034093 267.721882,142.034093 L272.705459,142.034093 Z"
                    id="Combined-Shape"
                    fill="#EBBE4C"
                  ></path>
                </g>
                <g id="Group-3" transform="translate(75.480975, 73.046105)">
                  <polygon
                    id="Rectangle-5"
                    fill="#D8D9D9"
                    points="129.859742 0 134.289561 127.424872 -4.4298182 127.424872 1.15463195e-14 0"
                  ></polygon>
                  <rect
                    id="Rectangle-6"
                    fill="#B9B9BC"
                    x="25.9719485"
                    y="22.4441536"
                    width="64.9298712"
                    height="34.7522379"
                    rx="8"
                  ></rect>
                  <rect
                    id="Rectangle-7"
                    fill="#B9B9BC"
                    x="25.9719485"
                    y="69.5044757"
                    width="64.9298712"
                    height="11.5840793"
                    rx="5.79203964"
                  ></rect>
                </g>
                <path
                  d="M147.715457,4.86974034 C147.715457,4.86974034 171.579726,10.2345093 189.234803,35.6507535 C195.86833,45.2003785 202.660924,57.2239502 205.477747,73.3753864 L211.33563,207.463746 L202.334855,207.874349 L197.938857,73.3753864 C197.938857,73.3753864 187.849736,38.6466143 179.525544,27.7498049 C170.408027,15.814492 147.715457,4.86974034 147.715457,4.86974034 Z"
                  id="Path-5"
                  fill="#4A4545"
                  opacity="0.276002799"
                ></path>
              </g>
              <g
                id="Group-5"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(70.978138, 587.241235) rotate(-4.000000) translate(-70.978138, -587.241235) translate(-45.895630, 499.779829)"
              >
                <polygon
                  id="Path-4"
                  fill="#C4C3C4"
                  points="73.3792876 174.623857 96.101811 124.353228 233.404545 0.718245716 63.3066244 109.44151"
                ></polygon>
                <polygon
                  id="Path-6"
                  fill="#ACACAE"
                  points="113.150288 132.656947 93.3796106 125.022865 73.4033432 174.641444"
                ></polygon>
                <path
                  d="M233.963311,0.857657671 L157.220647,149.673724 L92.4998072,125.369429 L233.963311,0.857657671 Z M233.21569,1.03465208 L63.808804,109.852948 L0.457700449,87.8785403 L233.21569,1.03465208 Z"
                  id="Combined-Shape"
                  fill="#D8D8D8"
                ></path>
              </g>
              <g
                id="Group-5-Copy"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-36.307363, 262.315812) rotate(65.000000) translate(36.307363, -262.315812) translate(-153.181132, 162.250703)"
              >
                <polygon
                  id="Path-4"
                  fill="#C4C3C4"
                  points="73.3792876 199.788179 96.101811 142.273258 233.404545 0.821749137 63.3066244 125.212673"
                ></polygon>
                <polygon
                  id="Path-6"
                  fill="#ACACAE"
                  points="113.150288 151.773591 93.3796106 143.039393 73.4033432 199.8083"
                ></polygon>
                <path
                  d="M240.857351,-0.553966448 L151.371701,168.65514 L85.6057673,146.023345 L240.857351,-0.553966448 Z M233.21569,1.18375152 L63.808804,125.683402 L0.457700449,100.542353 L233.21569,1.18375152 Z"
                  id="Combined-Shape"
                  fill="#D8D8D8"
                ></path>
              </g>
              <g
                id="Group-6"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(393.333857, 167.066937) rotate(-15.000000) translate(-393.333857, -167.066937) translate(325.157492, 126.442576)"
              >
                <rect
                  id="Rectangle-8"
                  fill="#EBBE4C"
                  x="0"
                  y="0"
                  width="135.839842"
                  height="81.0119948"
                  rx="8"
                ></rect>
                <polygon
                  id="Triangle-3"
                  fill="#E2B33B"
                  points="8.9780459 0 126.187699 0 67.3765614 35.517421"
                ></polygon>
              </g>
              <g
                id="quirks"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-159.510754, -38.864254)"
              >
                <ellipse
                  id="Oval"
                  stroke="#EBBE4C"
                  stroke-width="8"
                  cx="622.920951"
                  cy="657.820757"
                  rx="8.52204559"
                  ry="8.52204559"
                ></ellipse>
                <ellipse
                  id="Oval-Copy-3"
                  stroke="#67EB4C"
                  stroke-width="8"
                  cx="909.424008"
                  cy="764.955045"
                  rx="8.52204559"
                  ry="8.52204559"
                ></ellipse>
                <ellipse
                  id="Oval-Copy"
                  stroke="#E358FF"
                  stroke-width="8"
                  cx="65.3356829"
                  cy="475.205495"
                  rx="8.52204559"
                  ry="8.52204559"
                ></ellipse>
                <ellipse
                  id="Oval-Copy-2"
                  stroke="#E357FF"
                  stroke-width="8"
                  cx="333.171401"
                  cy="193.572178"
                  rx="8.52204559"
                  ry="8.52204559"
                ></ellipse>
                <polygon
                  id="Triangle-4"
                  stroke="#EBBE4C"
                  stroke-width="8"
                  stroke-linejoin="round"
                  transform="translate(223.196432, 841.653455) rotate(32.000000) translate(-223.196432, -841.653455) "
                  points="223.196432 831.913974 232.124289 851.392936 214.268575 851.392936"
                ></polygon>
                <polygon
                  id="Triangle-4-Copy"
                  stroke="#62C5FC"
                  stroke-width="8"
                  stroke-linejoin="round"
                  transform="translate(955.445574, 275.745990) rotate(51.000000) translate(-955.445574, -275.745990) "
                  points="955.445574 267.080647 963.569333 284.411333 947.321815 284.411333"
                ></polygon>
                <path
                  d="M21.305114,85.0175501 L21.305114,72.8507269 C21.305114,71.1647005 19.9424533,69.7996115 18.2615263,69.7996115 C16.5840195,69.7996115 15.2179386,71.1656424 15.2179386,72.8507269 L15.2179386,85.0175501 L3.0511154,85.0175501 C1.365089,85.0175501 0,86.3802107 0,88.0611378 C0,89.7386445 1.36603089,91.1047255 3.0511154,91.1047255 L15.2179386,91.1047255 L15.2179386,103.271549 C15.2179386,104.957575 16.5805992,106.322664 18.2615263,106.322664 C19.939033,106.322664 21.305114,104.956633 21.305114,103.271549 L21.305114,91.1047255 L33.4719371,91.1047255 C35.1579635,91.1047255 36.5230525,89.7420648 36.5230525,88.0611378 C36.5230525,86.383631 35.1570216,85.0175501 33.4719371,85.0175501 L21.305114,85.0175501 Z"
                  id="Combined-Shape"
                  fill="#62C5FC"
                ></path>
                <path
                  d="M662.487592,15.2179386 L662.487592,3.0511154 C662.487592,1.365089 661.124931,0 659.444004,0 C657.766497,0 656.400416,1.36603089 656.400416,3.0511154 L656.400416,15.2179386 L644.233593,15.2179386 C642.547567,15.2179386 641.182478,16.5805992 641.182478,18.2615263 C641.182478,19.939033 642.548509,21.305114 644.233593,21.305114 L656.400416,21.305114 L656.400416,33.4719371 C656.400416,35.1579635 657.763077,36.5230525 659.444004,36.5230525 C661.121511,36.5230525 662.487592,35.1570216 662.487592,33.4719371 L662.487592,21.305114 L674.654415,21.305114 C676.340441,21.305114 677.70553,19.9424533 677.70553,18.2615263 C677.70553,16.5840195 676.339499,15.2179386 674.654415,15.2179386 L662.487592,15.2179386 Z"
                  id="Combined-Shape-Copy"
                  fill="#67EB4C"
                ></path>
              </g>
              <g
                id="messages"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-62.115947, -67.271073)"
              >
                <g
                  id="Group-7-Copy"
                  transform="translate(96.509547, 54.875541) rotate(19.000000) translate(-96.509547, -54.875541) translate(53.899319, 11.859502)"
                >
                  <path
                    d="M47.8225032,84.9233289 C46.0315469,85.1558727 44.2055358,85.2757866 42.3517053,85.2757866 C18.9615043,85.2757866 2.30944941e-12,66.1861515 2.30944941e-12,42.6378933 C2.30944941e-12,19.0896351 18.9615043,1.41845856e-12 42.3517053,1.41845856e-12 C65.7419063,1.41845856e-12 84.7034106,19.0896351 84.7034106,42.6378933 C84.7034106,43.4859105 84.6788203,44.3281455 84.6303183,45.1639151 L84.7552994,85.736566 L47.8225032,84.9233289 Z"
                    id="Combined-Shape"
                    fill="#EBBE4C"
                  ></path>
                  <rect
                    id="Rectangle-10"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="22.1085373"
                    width="32.9402152"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="31.5836247"
                    width="32.9402152"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy-2"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="41.0587121"
                    width="17.2543985"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                </g>
                <g id="Group-7" transform="translate(0.000000, 33.919094)">
                  <path
                    d="M59.2911524,107.479029 C57.5242989,107.653623 55.7323765,107.743005 53.9195591,107.743005 C24.1406089,107.743005 0,83.6239118 0,53.8715025 C0,24.1190932 24.1406089,0 53.9195591,0 C83.6985094,0 107.839118,24.1190932 107.839118,53.8715025 C107.839118,54.7826904 107.816476,55.6885947 107.771723,56.5886843 L107.750633,108.38039 L59.2911524,107.479029 Z"
                    id="Combined-Shape"
                    fill="#62C5FC"
                  ></path>
                  <rect
                    id="Rectangle-10"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="27.9333717"
                    width="41.9374349"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="39.9048167"
                    width="41.9374349"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy-2"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="51.8762616"
                    width="21.9672278"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                </g>
              </g>
              <g
                id="messages-copy"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(725.970364, 555.244067) scale(-1, 1) translate(-725.970364, -555.244067) translate(650.489389, 483.821209)"
              >
                <g
                  id="Group-7-Copy"
                  transform="translate(96.509547, 54.875541) rotate(19.000000) translate(-96.509547, -54.875541) translate(53.899319, 11.859502)"
                >
                  <path
                    d="M47.8225032,84.9233289 C46.0315469,85.1558727 44.2055358,85.2757866 42.3517053,85.2757866 C18.9615043,85.2757866 2.30944941e-12,66.1861515 2.30944941e-12,42.6378933 C2.30944941e-12,19.0896351 18.9615043,1.41845856e-12 42.3517053,1.41845856e-12 C65.7419063,1.41845856e-12 84.7034106,19.0896351 84.7034106,42.6378933 C84.7034106,43.4859105 84.6788203,44.3281455 84.6303183,45.1639151 L84.7552994,85.736566 L47.8225032,84.9233289 Z"
                    id="Combined-Shape"
                    fill="#EBBE4C"
                  ></path>
                  <rect
                    id="Rectangle-10"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="22.1085373"
                    width="32.9402152"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="31.5836247"
                    width="32.9402152"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy-2"
                    fill="#FFFFFF"
                    x="21.9601435"
                    y="41.0587121"
                    width="17.2543985"
                    height="6.31672493"
                    rx="3.15836247"
                  ></rect>
                </g>
                <g id="Group-7" transform="translate(0.000000, 33.919094)">
                  <path
                    d="M59.2911524,107.479029 C57.5242989,107.653623 55.7323765,107.743005 53.9195591,107.743005 C24.1406089,107.743005 0,83.6239118 0,53.8715025 C0,24.1190932 24.1406089,0 53.9195591,0 C83.6985094,0 107.839118,24.1190932 107.839118,53.8715025 C107.839118,54.7826904 107.816476,55.6885947 107.771723,56.5886843 L107.750633,108.38039 L59.2911524,107.479029 Z"
                    id="Combined-Shape"
                    fill="#62C5FC"
                  ></path>
                  <rect
                    id="Rectangle-10"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="27.9333717"
                    width="41.9374349"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="39.9048167"
                    width="41.9374349"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                  <rect
                    id="Rectangle-10-Copy-2"
                    fill="#FFFFFF"
                    x="27.9582899"
                    y="51.8762616"
                    width="21.9672278"
                    height="7.98096333"
                    rx="3.99048167"
                  ></rect>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div className="contact-form-container">
          <form className="contact-form">
            <span className="form-header">Contact us</span>
            <input
              type="email"
              name="email"
              className="email-input"
              placeholder="Your Email"
              onChange={handleChange}
              value={credentials.email}
            />
            <textarea
              name="text"
              cols="30"
              rows="5"
              className="message"
              placeholder="Message..."
              onChange={handleChange}
              value={credentials.text}
            />
            <button className="submit" type="submit"
              onClick={handleClick}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
